import React from "react";
import I18n from "i18n-js";

import ActionButton from "../../../commons/ActionButton";

import insightsIcon from "../../../assets/icons/insights.svg";

const InsightsButton = ({ team }) => {
  return (
    <ActionButton
      title={I18n.t("dashboard.actions.view_insights")}
      icon={insightsIcon}
      href={`/teams/${team.uuid}/insights?locale=${I18n.locale}`}
    />
  );
}

export default InsightsButton;
